/** @jsx jsx */
import { jsx, Text } from 'theme-ui';

import { dateString } from '../utils/date';

export default function Date({ date }) {
  return <Text variant="dimHeader">{dateString(date)}</Text>;
}
